/* eslint-disable */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import DataTable from "../DataTable/DataTable";
import { getSubscribedCommunitiesList, getStatisticsSuccess } from "../../../actions";
import { history } from "../../../config/stores";
import { useParams } from "react-router-dom";
import Header from "../../Header/Header";
import "./SubscribedCommunities.scss";

const SubscribedCommunities = ({ getSubscribedCommunitiesList, getStatisticsSuccess, monthlyCommunities, annualCommunities }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const { type } = useParams(); // Get 'monthly' or 'annual' from URL

  // Determine the subscription type and labels
  const subscriptionType = type === 'monthly' ? 'monthly' : 'yearly'; // API uses 'yearly' instead of 'annual'
  const filterLabel = subscriptionType === 'monthly' ? 'MONTHLY SUBSCRIPTION' : 'ANNUAL SUBSCRIPTION';
  const stateKey = subscriptionType === 'monthly' ? 'monthlyCommunities' : 'annualCommunities';
  const subscribedCommunities = subscriptionType === 'monthly' ? monthlyCommunities : annualCommunities;

  useEffect(() => {
    // Set loading state and fetch subscribed communities
    getStatisticsSuccess({ type: stateKey, loading: true });
    setIsLoading(true);
    
    getSubscribedCommunitiesList({
      type: subscriptionType,
      name: "",
      participantsFrom: null,
      participantsTo: null,
      page: 1,
      limit: 20,
      onSuccess: () => setIsLoading(false),
      onError: () => setIsLoading(false)
    });
  }, [subscriptionType]); // Re-fetch when subscription type changes

  const handleLoadMore = () => {
    if (subscribedCommunities?.hasNextPage && !isLoading) {
      const nextPage = currentPage + 1;
      setCurrentPage(nextPage);
      setIsLoading(true);
      
      getSubscribedCommunitiesList({
        type: subscriptionType,
        name: "",
        participantsFrom: null,
        participantsTo: null,
        page: nextPage,
        limit: 20,
        onSuccess: () => setIsLoading(false),
        onError: () => setIsLoading(false)
      });
    }
  };

  const handleBackToDashboard = () => {
    history.push('/');
  };

  return (
    <>
      <Header />
      <div className="main-container">
        <div className="inner-header-container">
          <div className="left-part">
            <div 
              className="close-icon" 
              onClick={handleBackToDashboard}
              title="Back to Dashboard"
            />
            <div className="inner-title">SUBSCRIBED COMMUNITIES</div>
          </div>
          <div className="right-part">
            <div className="filter-label">
              <span className="filter-text">FILTERED BY:</span>
              <span className="filter-value">{filterLabel}</span>
            </div>
          </div>
        </div>
        <div className="body-container">
          <DataTable
            data={subscribedCommunities || { docs: [] }}
            preset="subscribedCommunities"
            isLoading={subscribedCommunities?.loading || isLoading}
            onLoadMore={handleLoadMore}
            hasMore={subscribedCommunities?.hasNextPage}
            emptyStateText={`No ${subscriptionType} subscribed communities found`}
          />
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  monthlyCommunities: state.dashboard.monthlyCommunities,
  annualCommunities: state.dashboard.annualCommunities,
});

const mapDispatchToProps = (dispatch) => ({
  getSubscribedCommunitiesList: (payload) => dispatch(getSubscribedCommunitiesList(payload)),
  getStatisticsSuccess: (payload) => dispatch(getStatisticsSuccess(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SubscribedCommunities);
